/**
 * 普通请求
 * params = qs.stringify(params)
 * 数组参数
 * params = qs.stringify( params , { arrayFormat: 'repeat' })
 * params = this.$qs.stringify(params, { indices: false })
 */
export default {
  relatedPath () {
    return process.env.NODE_ENV === 'production' ? './' : '/'
  },

  small_img_url: 'http://img.er07.com/imglib/'
}
